<div class="card section-card mb-3">
  <div class="card-header d-flex align-items-center justify-content-between gap-2">
    <span>{{ 'i18n.domain.theme-showcase.tenantTheme.title' | translate }}</span>
    <app-collapse-button [isExpanded]="isExpanded" (toggleExpand)="toggleExpanded()"></app-collapse-button>
  </div>
  @if (isExpanded) {
  <div class="card-body">
    <form class="row g-3 align-items-start" [formGroup]="tenantThemePreviewForm" (submit)="$event.preventDefault()">
      <div class="col-12 col-md-6 col-xl-3">
        <app-color-picker-field
          id="tenantThemePrimary"
          [labelKey]="'i18n.domain.theme-showcase.tenantTheme.primary'"
          [value]="tenantThemePreviewForm.controls.primary.value"
          (valueChange)="onTenantThemeColorChanged('primary', $event)">
        </app-color-picker-field>
      </div>
      <div class="col-12 col-md-6 col-xl-3">
        <app-color-picker-field
          id="tenantThemeSecondary"
          [labelKey]="'i18n.domain.theme-showcase.tenantTheme.secondary'"
          [value]="tenantThemePreviewForm.controls.secondary.value"
          (valueChange)="onTenantThemeColorChanged('secondary', $event)">
        </app-color-picker-field>
      </div>
      <div class="col-12 col-md-6 col-xl-3">
        <label class="form-label" for="tenantThemeLogo">{{ 'i18n.domain.theme-showcase.tenantTheme.logoUrl' | translate }}</label>
        <input id="tenantThemeLogo" type="text" class="form-control" formControlName="logoUrl" placeholder="https://example.com/logo.svg" />
      </div>
      <div class="col-12 col-md-6 col-xl-3">
        <label class="form-label" for="tenantThemeLogoDarkMode">
          {{ 'i18n.domain.theme-showcase.tenantTheme.logoUrlDarkMode' | translate }}
          <ejs-tooltip [content]="'i18n.domain.theme-showcase.tenantTheme.logoUrlDarkModeHint' | translate">
            <i class="icon-information" aria-hidden="true"></i>
          </ejs-tooltip>
        </label>
        <input id="tenantThemeLogoDarkMode" type="text" class="form-control" formControlName="logoUrlDarkMode" placeholder="https://example.com/logo-dark.svg" />
      </div>
    </form>

    <hr class="my-3" />

    <app-theme-token-override-editor
      [rows]="themeTokenOverrideRows"
      (rowsChange)="onThemeTokenOverrideRowsChange($event)">
    </app-theme-token-override-editor>

    <hr class="my-3" />

    <div class="d-flex flex-wrap gap-2 mt-3 justify-content-end">
      <button type="button" class="btn btn-outline-secondary" (click)="resetTenantThemePreview()">
        {{ 'i18n.domain.theme-showcase.tenantTheme.resetButton' | translate }}
      </button>
      <button type="button" class="btn btn-primary" [disabled]="isSaving || !selectedClient || !isClientThemeDirty" (click)="saveTenantThemePreview()">
        {{ 'i18n.domain.theme-showcase.tenantTheme.save.saveButton' | translate }}
      </button>
    </div>
  </div>
  }
</div>

<app-theme-quick-editor
  [rows]="themeTokenOverrideRows"
  [primary]="tenantThemePreviewForm.controls.primary.value"
  [secondary]="tenantThemePreviewForm.controls.secondary.value"
  [originalPrimary]="originalPrimary"
  [originalSecondary]="originalSecondary"
  (rowsChange)="onThemeTokenOverrideRowsChange($event)"
  (primaryChange)="onTenantThemeColorChanged('primary', $event)"
  (secondaryChange)="onTenantThemeColorChanged('secondary', $event)">
</app-theme-quick-editor>
